<template>
  <transition name="alert">
    <div v-if="show" data-type="alert" class="capusta_alert">
      <div :class="['alert', getClass]">
        <p><span>{{ $t(text) }}</span></p>
      </div>
    </div>
  </transition>
</template>

<script>
import { events } from './events';

const showTime = 3400;

export default {
  name: 'capustaAlert',
  mounted() {
    events.$on('show', this.init);
  },
  data() {
    return {
      show: false,
      text: 'cabbage',
      type: 'cabbage',
    };
  },
  computed: {
    getClass() {
      const CLASSES_MAP = {
        success: 'warning alert-icon--yo',
        warning: 'error alert-icon--cat',
        cabbage: 'note alert-icon--cabbage',
        ok: 'note alert-icon--ok',
        golubok: 'info alert-icon--golubok',
      };

      return CLASSES_MAP[this.type];
    },
  },
  methods: {
    showAlert(params) {
      this.type = params.type;
      this.text = params.text;
      this.show = true;
    },
    async init(params) {
      if (!params) { return; }

      if (this.show) {
        this.show = false;
        clearTimeout(this._timer);
        await this.$nextTick();
      }

      this.showAlert(params);
      this._timer = setTimeout(() => this.show = false, showTime);
    },
  },
};
</script>

<style lang="sass" scoped>
.capusta_alert
    position: fixed
    z-index: 9999
    top: 0
    left: 0
    right: 0
    text-align: center
    overflow: hidden

</style>
